// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"4bae69d9","397":"06464717","687":"4bae69d9","949":"4bae69d9"}[chunkId] + ".chunk.css";
};